import Button from '../ui/Button.jsx';
import { Card, CardBody } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const TextBox = ({ heading_img, heading, text, items, fn }) => {
    return (
        <div className="component-email">
            <div className="row">
                <HeadingOne className="w-8/12" image={heading_img} heading={heading} />
            </div>
            <div className="row justify-center">
                <div className="col xl:w-10/12">
                    <Card>
                        <CardBody>
                            <div className="row items-center justify-center">
                                <div className="col text-xl">
                                    <div dangerouslySetInnerHTML={{ __html: text }}></div>
                                </div>
                                <div className="col text-xl">
                                    <div className="flex justify-center gap-12">
                                        {items?.map((item, index) =>
                                            item.button ? (
                                                <Button key={index} {...item.button} onClick={() => fn.handleAction(item.button.action)} />
                                            ) : null,
                                        )}
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default TextBox;
